module.exports = __webpack_public_path__ + "img/português.f1b718e6.svg";